import { EskerOrderIssueType } from '../../../../enums';

export interface IEskerSubtypeDom {
    issueType: EskerOrderIssueType;
}
